import { useState, useEffect } from 'react'

import { getProvincesAPI } from '../services/address'
import { getTrainingListExpireAPI } from '../services/certificate'

function UseExpied() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingListExpireAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.expire }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseExpied
